module.exports = "<ng-form name=$ctrl.form ng-class=\"{'inline': $ctrl.showInline, 'box': !$ctrl.showInline}\"> <app-checkbox field=$ctrl.all label=\"{{ 'All' | translate }}\" disabled=$ctrl.readOnly ng-if=$ctrl.showAllOption> </app-checkbox> <app-checkbox ng-repeat=\"entry in $ctrl.options\" field=entry.checked label=\"{{ entry.value | appTranslateEnum:$ctrl.enumType }}\" disabled=$ctrl.readOnly> </app-checkbox> </ng-form> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/checkboxespanel/partial.html
// module id = 535
// module chunks = 0